import * as React from 'react';

import Loading from '../misc/components/loading';
import { NotificationModalDetail } from './NotificationModalDetail';
import { NotificationItem } from './NotificationItem';
import { Alert, AlertNotification } from 'webportalclient';
import { Link } from 'react-router-dom';
import Modal from '../misc/components/modal';

interface NotificationModalProps {
    alerts: AlertNotification[];
    isFetching: boolean;
    onRefresh: () => void;
    onClose: () => void;
}

export const NotificationModal = (props: NotificationModalProps) => {

    const [selectedNotification, setSelectedNotification] = React.useState<Alert>();
    const [fullViewVisible, setFullViewVisible] = React.useState<boolean>();

    const handleClickThrough = (event, notificationId: string) => {
        setSelectedNotification(props.alerts.find(a => a.id === notificationId));
        setFullViewVisible(true);
        props.onRefresh();
    }

    const renderNotification = () => {
        if (props.isFetching) {
            return <Loading />;
        } else if (fullViewVisible) {
            return null;
        } else if (props.alerts.filter(x => !x.isRead).length === 0) {
            return (<div>There are no new notifications</div>);
        } else {
            return props.alerts.filter(x => !x.isRead).map((alert) => {
                return <NotificationItem key={`NotificationItem${alert.id}`} id={alert.id} icon="fa-exclamation-triangle" headline={alert.alert.headline} dateTime={alert.alert.occurred} handleClickThrough={(event, id) => handleClickThrough(event, id)} />
            });
        }
    }

    return (
        <Modal show={true} closeModalHandler={props.onClose}>
            <div key="notificationsRoot" id="notificationsRoot">               
                <div className="panel panel-default">
                    <div className="panel-body">
                        <div className="row">
                            <div className="col-sm-6">
                                <h2 className="text-primary">Unread Notifications</h2>
                            </div>
                            <div className="h2 pull-right col-sm-6">
                                <Link to="/alerts" onClick={() => props.onClose()} className="btn btn-primary btn-outline pull-right">View All Alerts</Link>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <ul className="list-group">
                                    {renderNotification()}
                                </ul>
                            </div>
                        </div>
                        <NotificationModalDetail alert={selectedNotification} visible={fullViewVisible} onClose={() => { setFullViewVisible(false); setSelectedNotification(undefined); props.onRefresh() }} />
                    </div>               
                </div>                
            </div>
        </Modal>
    );

}
